import { render, staticRenderFns } from "./ViewArquivo.vue?vue&type=template&id=3a994f3b"
import script from "./ViewArquivo.vue?vue&type=script&lang=js"
export * from "./ViewArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports